export default __webpack_public_path__ + "static/media/correspondent10.ce6bc265.png";